var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconEdit = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2455 10.9616C28.0307 10.1764 28.0307 8.90332 27.2455 8.11812L24.057 4.92972C23.2719 4.14452 21.9988 4.14452 21.2136 4.92972L5.27938 20.8639C5.12557 21.0177 5.0258 21.2173 4.99504 21.4326L4.22668 26.8111C4.1319 27.4746 4.70059 28.0433 5.36406 27.9485L10.7425 27.1801C10.9579 27.1494 11.1574 27.0496 11.3112 26.8958L27.2455 10.9616ZM10.069 25.2453L6.40665 25.7685L6.92983 22.1063H8.05837V24.1169H10.069V25.2453ZM22.8078 12.5558L12.0796 23.284V22.1063H10.069V20.0956H8.8912L19.6194 9.36742L22.8078 12.5558ZM24.2295 11.1341L21.0411 7.94566L22.6353 6.35144L25.8237 9.53985L24.2295 11.1341Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconEdit);
export default ForwardRef;